import { onboarding } from '@services';
import Onboarding, {
  IOnboardingFile,
  IOnboardingFileApi,
  IPaginationResultFiles,
} from '@models/Onboarding.model';

interface IRequest {
  studioId: string;
  perPage: number;
  page: number;
  status: string | null;
  search: string;
}

const getSearchFiles = async ({
  studioId,
  perPage,
  page,
  status,
  search,
}: IRequest): Promise<IPaginationResultFiles<IOnboardingFile>> => {
  const { data: files } = await onboarding.get<
    IPaginationResultFiles<IOnboardingFileApi>
  >(
    `/api/v1/file/search?studioId=${studioId}&perPage=${perPage}&page=${page}&status=${status}&search=${search}`,
  );

  return Onboarding.arrayPaginatedFromApiModel(files);
};

export { getSearchFiles };
